<template>
    <div>
        <h3>
            <svg class="c-a-icon title-icon">
                <use :href="`/assets/icons/icons.svg#${icon}`" :xlink:href="`/assets/icons/icons.svg#${icon}`"></use>
            </svg>
            <slot></slot>
        </h3>
    </div>
</template>

<script>
export default {
    props:{
        icon: String,
        title: String
    }
}
</script>

<style scoped>
.title-icon{
    vertical-align: sub;
    color:rgb(233, 131, 0);
}
</style>


// WEBPACK FOOTER //
// src/views/components/atoms/AtomTitle.vue